import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [activeTab, setActiveTab] = useState('best-match');
  const [viewMode, setViewMode] = useState('client'); // 'client' or 'admin'
  const navigate = useNavigate();

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.trim()) {
      setIsSearching(true);
      navigate('/app/search');
    } else {
      setIsSearching(false);
    }
  };

  const clearSearch = () => {
    setSearchQuery('');
    setIsSearching(false);
    setActiveTab('best-match');
  };

  const toggleViewMode = (mode) => {
    setViewMode(mode);
    // Reset to best match when switching modes
    setActiveTab('best-match');
  };

  const value = {
    searchQuery,
    setSearchQuery,
    isSearching,
    setIsSearching,
    activeTab,
    setActiveTab,
    viewMode,
    toggleViewMode,
    handleSearch,
    clearSearch
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};
